import toast from "react-hot-toast";

export function successToast(entity: string, id?: string, version?: string, deleted?: boolean){
    if(version){
        toast.success(`${entity} Restored`)
    } else if(deleted){
        toast.success(`${entity} Deleted`)
    }else {
        toast.success(`${entity} ${id ? "Updated" : "Created"}`)
    }
}

export function errorToast(entity: string, id?: string, version?: string, deleted?: boolean){
    if(version){
        toast.error(`${entity} failed Restore`)
    }  else if(deleted){
        toast.error(`Failed deleting ${entity}`)
    } else {
        toast.error(`${entity} failed ${id ? "Updating" : "Creation"}`)
    }
}